import React, {Component} from 'react';
import {formatTime} from "../../../../utils";
import BaseTable from "../../../components/baseTable/BaseTable";
import {contentParser} from "../../../../base/BaseComponent";

class SimpleFieldTable extends Component{

    static defaultProps = {
        maxWidth: 600,
        columns:[],
        dataSource:[]
    };

    constructor(props) {
        super(props);
    }

    //渲染表格
    renderTable=()=>{

        const columns = this.props.columns;
        const dataSource = this.props.data;
        let  newArray = dataSource&&dataSource.length&&dataSource.filter(item => item.status !== '隐藏');
        let newColumns = [];
        let that = this;
        columns&&columns.length&&columns.forEach((item,index)=>{
            let extend = item.renderComponent;
            if(extend){
                let regx = /^\$\{renderExtend\.([^.}]*)\}$/;
                if(regx.test(extend)) {
                    let renderExtendComponentName = extend.replace(regx, "$1");
                    try {
                        let RenderExtendComponent = require(`../columnRender/${renderExtendComponentName}`).default;
                        delete item.renderComponent;
                        item.render = (text, record) => <RenderExtendComponent {...item} record={record} text={text} tableComponent={that} />
                    }catch (e) {
                        console.error(e);
                    }
                }
            }
            newColumns.push(item)
        });
        dataSource.length && dataSource.forEach((item)=>{
            newColumns && newColumns.map(column=>{
                if(column.dateTime){
                    console.log(column.dateTime,column.dataIndex,'column.dateTime');
                    let _formatTime = formatTime;
                    let time = "";
                    try {
                        eval(`time = isNaN(item.${column.dataIndex})?item.${column.dataIndex}:_formatTime(item.${column.dataIndex})`);
                        if (time) {
                            eval(`item.${column.dataIndex} = "${time}"`);
                        }else {
                            eval(`item.${column.dataIndex} = "-"`);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        });
        return <BaseTable columns={newColumns} dataSource={newArray}/>;
    };

    parseListBtn(record) {
        let res = [];
        if (this.props.listOpBtns) {
            contentParser(this.props.listOpBtns, {component: this});
            let btns = this.props.listOpBtns;
            for (let i = 0; btns && i < btns.length; i++) {
                let btn = btns[i];
                if(btn.extend){
                    let extend = btn.extend;
                    let regx = /^\$\{btnExtend\.([^.}]*)\}$/;
                    if(regx.test(extend)){
                        let btnExtendComponentName = extend.replace(regx, "$1");
                        try {
                            let btnExtendComponent = require(`../tableBtnExtend/${btnExtendComponentName}`).default;
                            let otherParams = btn.otherParams || {};
                            contentParser(otherParams, {record});
                            let extendObj = btnExtendComponent({component:this, record, ...otherParams});
                            if(typeof extendObj === "object"){
                                res.push(extendObj);
                            }
                        }catch (e) {
                            console.error(e);
                        }
                    }
                }else{
                    res.push(btn);
                }
            }
        }
        console.log("========fff===",res);
        return res;
    }

    render() {
        return <div style={{display:"inline-block"}}>
            <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} style={{margin:"10px 0"}}><tbody><tr>
                <td width={100} align={"right"} valign={"top"} style={{color: "#aaa6a6"}}>
                    {this.props.label}：
                </td>
                <td style={{width:this.props.maxWidth}} valign={"top"}>
                    {this.renderTable()}
                </td>
            </tr></tbody></table>
        </div>;
    }
}

export default SimpleFieldTable;
